
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  createQualification,
  searchQualifications,
  updateQualification,
  deleteQualification,
  createRole,
  searchRoles,
  updateRole,
  deleteRole,
  createFacilityType,
  searchFacilityTypes,
  updateFacilityType,
  deleteFacilityType,
  createDesignation,
  searchDesignations,
  updateDesignation,
  deleteDesignation,
  deleteDocumentType,
  createDocumentType,
  searchDocumentTypes,
  updateDocumentType,
  createRoleDocumentMapping,
  getRoleDocumentMapping,
  createFacilityTypeDocumentMapping,
  getFacilityTypeDocumentMapping,
  searchCancellationReasons,
  createCancellationReason,
  updateCancellationReason,
  deleteCancellationReason,
  searchBanks,
  uploadBankCSV,
  createConfig,
  searchConfigs,
  updateConfig,
  deleteConfig,
  listConfigs,
  fetchCustomForms,
  createCustomForm,
  updateCustomForm,
  mapInputsToForm,
  deleteCustomForm,
  publishCustomForm,
  deleteCustomFormField,
  getBankFormFields,
  getBankForms,
  createBankFormField,
  getCustomFormFields,
  addCustomFormField,
  updateCustomFormField,
  updateBankFormField,
  deleteBankFormField,
  softDeleteBankFormField
} from './actions';



import {
  IMasterDataState,
  ICreateQualificationResponse,
  ICreateRoleState,
  ICreateRoleResponse,
  ISearchRoleState,
  IUpdateRoleState,
  IDeleteRoleState,
  ICreateFacilityTypeState,
  ICreateFacilityTypeResponse,
  ISearchFacilityTypeState,
  IUpdateFacilityTypeState,
  IDeleteFacilityTypeState,
  IFacilityType,
  ICreateDocumentTypeState,
  ICreateDocumentTypeResponse,
  ISearchDocumentTypeState,
  IUpdateDocumentTypeState,
  IDeleteDocumentTypeState,
  IDocumentType,
  ICreateDesignationState,
  ICreateDesignationResponse,
  ISearchDesignationState,
  IUpdateDesignationState,
  IDeleteDesignationState,
  IDesignation,
  ICreateRoleDocumentMappingState,
  IGetRoleDocumentMappingState,
  ICreateRoleDocumentMappingResponse,
  IGetRoleDocumentMappingResponse,
  ICreateFacilityTypeDocumentMappingState,
  ICreateFacilityTypeDocumentMappingResponse,
  IGetFacilityTypeDocumentMappingState,
  IGetFacilityTypeDocumentMappingResponse,
  ISearchCancellationReasonsState,
  ICreateCancellationReasonState,
  IUpdateCancellationReasonState,
  IDeleteCancellationReasonState,
  ISearchCancellationReasonsResponse,
  ISearchBankState,
  IUploadBankCSVState,
  ICreateConfigState,
  ICreateConfigResponse,
  ISearchConfigState,
  IUpdateConfigState,
  IDeleteConfigState,
  IConfig,
  IListConfigState,
  CustomFormState,
  CustomForm,
  IMapInputsToFormState,
  IMapInputsToFormResponse,
  IDeleteCustomFormState,
  IDeleteCustomFormResponse,
  IPublishCustomFormState,
  IPublishCustomFormResponse,

  IGetBankFormFieldsState,
  IGetBankFormFieldsResponse,
  IBankFormListState,
  IBankFormListResponse,
  ICreateBankFormFieldState,
  ICreateBankFormFieldResponse,
  IUpdateBankFormFieldState,
  IDeleteBankFormFieldState,
  ISoftDeleteBankFormFieldState,
  IGetCustomFormFieldsState,
  IGetCustomFormFieldsResponse,
  IAddCustomFormFieldState,
  IDeleteCustomFormFieldState,
  IDeleteCustomFormFieldResponse,
  IUpdateCustomFormFieldState,
} from './types';





const initialState: IMasterDataState = {
  loading: false,
  success: false,
  error: null,
  qualification: null,
};

const createQualificationSlice = createSlice({
  name: 'createQualification',
  initialState,
  reducers: {
    resetQualificationState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.qualification = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createQualification.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(createQualification.fulfilled, (state, action: PayloadAction<ICreateQualificationResponse>) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.qualification = action.payload.data;
      })
      .addCase(createQualification.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetQualificationState } = createQualificationSlice.actions;
export const createQualificationReducer = createQualificationSlice.reducer;

// Search Qualifications Slice
const initialSearchState: any = { // Using explicit types would require importing them all
  loading: false,
  success: false,
  error: null,
  qualifications: [],
  count: 0,
};



const searchQualificationsSlice = createSlice({
  name: 'searchQualifications',
  initialState: initialSearchState,
  reducers: {
    resetSearchState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.qualifications = [];
      state.count = 0;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchQualifications.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(searchQualifications.fulfilled, (state, action: any) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        if (action.payload && action.payload.data) {
          state.qualifications = action.payload.data.results;
          state.count = action.payload.data.count;
        } else {
          state.qualifications = [];
          state.count = 0;
        }
      })
      .addCase(searchQualifications.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetSearchState } = searchQualificationsSlice.actions;
export const searchQualificationsReducer = searchQualificationsSlice.reducer;

// Update Qualification Slice
const initialUpdateState: any = {
  loading: false,
  success: false,
  error: null,
};

const updateQualificationSlice = createSlice({
  name: 'updateQualification',
  initialState: initialUpdateState,
  reducers: {
    resetUpdateState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateQualification.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateQualification.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(updateQualification.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetUpdateState } = updateQualificationSlice.actions;
export const updateQualificationReducer = updateQualificationSlice.reducer;

// Delete Qualification Slice
const initialDeleteState: any = {
  loading: false,
  success: false,
  error: null,
};

const deleteQualificationSlice = createSlice({
  name: 'deleteQualification',
  initialState: initialDeleteState,
  reducers: {
    resetDeleteState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteQualification.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(deleteQualification.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(deleteQualification.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetDeleteState } = deleteQualificationSlice.actions;
export const deleteQualificationReducer = deleteQualificationSlice.reducer;


// Create Role Slice
const initialCreateRoleState: ICreateRoleState = {
  loading: false,
  success: false,
  error: null,
  role: null,
};

const createRoleSlice = createSlice({
  name: 'createRole',
  initialState: initialCreateRoleState,
  reducers: {
    resetCreateRoleState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.role = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createRole.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(createRole.fulfilled, (state, action: PayloadAction<ICreateRoleResponse>) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.role = action.payload.data;
      })
      .addCase(createRole.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetCreateRoleState } = createRoleSlice.actions;
export const createRoleReducer = createRoleSlice.reducer;

// Search Roles Slice
const initialSearchRolesState: ISearchRoleState = {
  loading: false,
  success: false,
  error: null,
  roles: [],
  count: 0,
};

const searchRolesSlice = createSlice({
  name: 'searchRoles',
  initialState: initialSearchRolesState,
  reducers: {
    resetSearchRolesState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.roles = [];
      state.count = 0;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchRoles.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(searchRoles.fulfilled, (state, action: any) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        // Handle potentially wrapped or unwrapped data structure
        if (action.payload && action.payload.data && Array.isArray(action.payload.data.results)) {
          state.roles = action.payload.data.results;
          state.count = action.payload.data.count;
        } else if (action.payload && Array.isArray(action.payload.results)) {
          state.roles = action.payload.results;
          state.count = action.payload.count;
        } else {
          state.roles = [];
          state.count = 0;
        }
      })
      .addCase(searchRoles.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetSearchRolesState } = searchRolesSlice.actions;
export const searchRolesReducer = searchRolesSlice.reducer;

// Update Role Slice
const initialUpdateRoleState: IUpdateRoleState = {
  loading: false,
  success: false,
  error: null,
};

const updateRoleSlice = createSlice({
  name: 'updateRole',
  initialState: initialUpdateRoleState,
  reducers: {
    resetUpdateRoleState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateRole.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateRole.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(updateRole.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetUpdateRoleState } = updateRoleSlice.actions;
export const updateRoleReducer = updateRoleSlice.reducer;

// Delete Role Slice
const initialDeleteRoleState: IDeleteRoleState = {
  loading: false,
  success: false,
  error: null,
};

const deleteRoleSlice = createSlice({
  name: 'deleteRole',
  initialState: initialDeleteRoleState,
  reducers: {
    resetDeleteRoleState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteRole.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(deleteRole.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(deleteRole.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetDeleteRoleState } = deleteRoleSlice.actions;
export const deleteRoleReducer = deleteRoleSlice.reducer;


// Create Facility Type Slice
const initialCreateFacilityTypeState: ICreateFacilityTypeState = {
  loading: false,
  success: false,
  error: null,
  facilityType: null,
};

const createFacilityTypeSlice = createSlice({
  name: 'createFacilityType',
  initialState: initialCreateFacilityTypeState,
  reducers: {
    resetCreateFacilityTypeState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.facilityType = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createFacilityType.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(createFacilityType.fulfilled, (state, action: PayloadAction<ICreateFacilityTypeResponse>) => {
        state.loading = false;
        state.success = true;
        state.error = null;

        if (action.payload.data) {
          state.facilityType = action.payload.data;
        } else {
          state.facilityType = action.payload as unknown as IFacilityType;
        }
      })
      .addCase(createFacilityType.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetCreateFacilityTypeState } = createFacilityTypeSlice.actions;
export const createFacilityTypeReducer = createFacilityTypeSlice.reducer;

// Search Facility Types Slice
const initialSearchFacilityTypesState: ISearchFacilityTypeState = {
  loading: false,
  success: false,
  error: null,
  facilityTypes: [],
  count: 0,
};

const searchFacilityTypesSlice = createSlice({
  name: 'searchFacilityTypes',
  initialState: initialSearchFacilityTypesState,
  reducers: {
    resetSearchFacilityTypesState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.facilityTypes = [];
      state.count = 0;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchFacilityTypes.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(searchFacilityTypes.fulfilled, (state, action: any) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        if (action.payload && action.payload.results) {
          state.facilityTypes = action.payload.results;
          state.count = action.payload.count;
        } else if (action.payload && action.payload.data && action.payload.data.results) {
          state.facilityTypes = action.payload.data.results;
          state.count = action.payload.data.count;
        } else {
          state.facilityTypes = [];
          state.count = 0;
        }
      })
      .addCase(searchFacilityTypes.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetSearchFacilityTypesState } = searchFacilityTypesSlice.actions;
export const searchFacilityTypesReducer = searchFacilityTypesSlice.reducer;

// Update Facility Type Slice
const initialUpdateFacilityTypeState: IUpdateFacilityTypeState = {
  loading: false,
  success: false,
  error: null,
};

const updateFacilityTypeSlice = createSlice({
  name: 'updateFacilityType',
  initialState: initialUpdateFacilityTypeState,
  reducers: {
    resetUpdateFacilityTypeState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateFacilityType.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateFacilityType.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(updateFacilityType.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetUpdateFacilityTypeState } = updateFacilityTypeSlice.actions;
export const updateFacilityTypeReducer = updateFacilityTypeSlice.reducer;

// Delete Facility Type Slice
const initialDeleteFacilityTypeState: IDeleteFacilityTypeState = {
  loading: false,
  success: false,
  error: null,
};

const deleteFacilityTypeSlice = createSlice({
  name: 'deleteFacilityType',
  initialState: initialDeleteFacilityTypeState,
  reducers: {
    resetDeleteFacilityTypeState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteFacilityType.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(deleteFacilityType.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(deleteFacilityType.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetDeleteFacilityTypeState } = deleteFacilityTypeSlice.actions;
export const deleteFacilityTypeReducer = deleteFacilityTypeSlice.reducer;

// Create Document Type Slice
const initialCreateDocumentTypeState: ICreateDocumentTypeState = {
  loading: false,
  success: false,
  error: null,
  documentType: null,
};

const createDocumentTypeSlice = createSlice({
  name: 'createDocumentType',
  initialState: initialCreateDocumentTypeState,
  reducers: {
    resetCreateDocumentTypeState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.documentType = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createDocumentType.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(createDocumentType.fulfilled, (state, action: PayloadAction<ICreateDocumentTypeResponse>) => {
        state.loading = false;
        state.success = true;
        state.error = null;

        if (action.payload.data) {
          state.documentType = action.payload.data;
        } else {
          state.documentType = action.payload as unknown as IDocumentType;
        }
      })
      .addCase(createDocumentType.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetCreateDocumentTypeState } = createDocumentTypeSlice.actions;
export const createDocumentTypeReducer = createDocumentTypeSlice.reducer;

// Search Document Types Slice
const initialSearchDocumentTypesState: ISearchDocumentTypeState = {
  loading: false,
  success: false,
  error: null,
  documentTypes: [],
  count: 0,
};

const searchDocumentTypesSlice = createSlice({
  name: 'searchDocumentTypes',
  initialState: initialSearchDocumentTypesState,
  reducers: {
    resetSearchDocumentTypesState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.documentTypes = [];
      state.count = 0;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchDocumentTypes.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(searchDocumentTypes.fulfilled, (state, action: any) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        if (action.payload && action.payload.results) {
          state.documentTypes = action.payload.results;
          state.count = action.payload.count;
        } else if (action.payload && action.payload.data && action.payload.data.results) {
          state.documentTypes = action.payload.data.results;
          state.count = action.payload.data.count;
        } else {
          state.documentTypes = [];
          state.count = 0;
        }
      })
      .addCase(searchDocumentTypes.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetSearchDocumentTypesState } = searchDocumentTypesSlice.actions;
export const searchDocumentTypesReducer = searchDocumentTypesSlice.reducer;

// Update Document Type Slice
const initialUpdateDocumentTypeState: IUpdateDocumentTypeState = {
  loading: false,
  success: false,
  error: null,
};

const updateDocumentTypeSlice = createSlice({
  name: 'updateDocumentType',
  initialState: initialUpdateDocumentTypeState,
  reducers: {
    resetUpdateDocumentTypeState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateDocumentType.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateDocumentType.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(updateDocumentType.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetUpdateDocumentTypeState } = updateDocumentTypeSlice.actions;
export const updateDocumentTypeReducer = updateDocumentTypeSlice.reducer;

// Delete Document Type Slice
const initialDeleteDocumentTypeState: IDeleteDocumentTypeState = {
  loading: false,
  success: false,
  error: null,
};

const deleteDocumentTypeSlice = createSlice({
  name: 'deleteDocumentType',
  initialState: initialDeleteDocumentTypeState,
  reducers: {
    resetDeleteDocumentTypeState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteDocumentType.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(deleteDocumentType.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(deleteDocumentType.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetDeleteDocumentTypeState } = deleteDocumentTypeSlice.actions;
export const deleteDocumentTypeReducer = deleteDocumentTypeSlice.reducer;


// Create Designation Slice
const initialCreateDesignationState: ICreateDesignationState = {
  loading: false,
  success: false,
  error: null,
  designation: null,
};

const createDesignationSlice = createSlice({
  name: 'createDesignation',
  initialState: initialCreateDesignationState,
  reducers: {
    resetCreateDesignationState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.designation = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createDesignation.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(createDesignation.fulfilled, (state, action: PayloadAction<ICreateDesignationResponse>) => {
        state.loading = false;
        state.success = true;
        state.error = null;

        if (action.payload.data) {
          state.designation = action.payload.data;
        } else {
          state.designation = action.payload as unknown as IDesignation;
        }
      })
      .addCase(createDesignation.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetCreateDesignationState } = createDesignationSlice.actions;
export const createDesignationReducer = createDesignationSlice.reducer;

// Search Designation Slice
const initialSearchDesignationState: ISearchDesignationState = {
  loading: false,
  success: false,
  error: null,
  designations: [],
  count: 0,
};

const searchDesignationSlice = createSlice({
  name: 'searchDesignation',
  initialState: initialSearchDesignationState,
  reducers: {
    resetSearchDesignationState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.designations = [];
      state.count = 0;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchDesignations.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(searchDesignations.fulfilled, (state, action: any) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        if (action.payload && action.payload.results) {
          state.designations = action.payload.results;
          state.count = action.payload.count;
        } else if (action.payload && action.payload.data && action.payload.data.results) {
          state.designations = action.payload.data.results;
          state.count = action.payload.data.count;
        } else {
          state.designations = [];
          state.count = 0;
        }
      })
      .addCase(searchDesignations.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetSearchDesignationState } = searchDesignationSlice.actions;
export const searchDesignationsReducer = searchDesignationSlice.reducer;

// Update Designation Slice
const initialUpdateDesignationState: IUpdateDesignationState = {
  loading: false,
  success: false,
  error: null,
};

const updateDesignationSlice = createSlice({
  name: 'updateDesignation',
  initialState: initialUpdateDesignationState,
  reducers: {
    resetUpdateDesignationState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateDesignation.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateDesignation.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(updateDesignation.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetUpdateDesignationState } = updateDesignationSlice.actions;
export const updateDesignationReducer = updateDesignationSlice.reducer;

// Delete Designation Slice
const initialDeleteDesignationState: IDeleteDesignationState = {
  loading: false,
  success: false,
  error: null,
};

const deleteDesignationSlice = createSlice({
  name: 'deleteDesignation',
  initialState: initialDeleteDesignationState,
  reducers: {
    resetDeleteDesignationState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteDesignation.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(deleteDesignation.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(deleteDesignation.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetDeleteDesignationState } = deleteDesignationSlice.actions;
export const deleteDesignationReducer = deleteDesignationSlice.reducer;

// Create Role Document Mapping Slice
const initialCreateRoleDocumentMappingState: ICreateRoleDocumentMappingState = {
  loading: false,
  success: false,
  error: null,
  message: null,
};

const createRoleDocumentMappingSlice = createSlice({
  name: 'createRoleDocumentMapping',
  initialState: initialCreateRoleDocumentMappingState,
  reducers: {
    resetCreateRoleDocumentMappingState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.message = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createRoleDocumentMapping.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(createRoleDocumentMapping.fulfilled, (state, action: PayloadAction<ICreateRoleDocumentMappingResponse>) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.message = action.payload.message;
      })
      .addCase(createRoleDocumentMapping.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
        state.message = null;
      });
  },
});

export const { resetCreateRoleDocumentMappingState } = createRoleDocumentMappingSlice.actions;
export const createRoleDocumentMappingReducer = createRoleDocumentMappingSlice.reducer;

// Get Role Document Mapping Slice
const initialGetRoleDocumentMappingState: IGetRoleDocumentMappingState = {
  loading: false,
  success: false,
  error: null,
  mapping: null,
};

const getRoleDocumentMappingSlice = createSlice({
  name: 'getRoleDocumentMapping',
  initialState: initialGetRoleDocumentMappingState,
  reducers: {
    resetGetRoleDocumentMappingState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.mapping = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRoleDocumentMapping.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(getRoleDocumentMapping.fulfilled, (state, action: PayloadAction<IGetRoleDocumentMappingResponse>) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.mapping = action.payload.data;
      })
      .addCase(getRoleDocumentMapping.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetGetRoleDocumentMappingState } = getRoleDocumentMappingSlice.actions;
export const getRoleDocumentMappingReducer = getRoleDocumentMappingSlice.reducer;

// Create Facility Type Document Mapping Slice
const initialCreateFacilityTypeDocumentMappingState: ICreateFacilityTypeDocumentMappingState = {
  loading: false,
  success: false,
  error: null,
  message: null,
};

const createFacilityTypeDocumentMappingSlice = createSlice({
  name: 'createFacilityTypeDocumentMapping',
  initialState: initialCreateFacilityTypeDocumentMappingState,
  reducers: {
    resetCreateFacilityTypeDocumentMappingState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.message = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createFacilityTypeDocumentMapping.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(createFacilityTypeDocumentMapping.fulfilled, (state, action: PayloadAction<ICreateFacilityTypeDocumentMappingResponse>) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.message = action.payload.message;
      })
      .addCase(createFacilityTypeDocumentMapping.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
        state.message = null;
      });
  },
});

export const { resetCreateFacilityTypeDocumentMappingState } = createFacilityTypeDocumentMappingSlice.actions;
export const createFacilityTypeDocumentMappingReducer = createFacilityTypeDocumentMappingSlice.reducer;

// Get Facility Type Document Mapping Slice
const initialGetFacilityTypeDocumentMappingState: IGetFacilityTypeDocumentMappingState = {
  loading: false,
  success: false,
  error: null,
  mapping: null,
};

const getFacilityTypeDocumentMappingSlice = createSlice({
  name: 'getFacilityTypeDocumentMapping',
  initialState: initialGetFacilityTypeDocumentMappingState,
  reducers: {
    resetGetFacilityTypeDocumentMappingState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.mapping = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFacilityTypeDocumentMapping.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(getFacilityTypeDocumentMapping.fulfilled, (state, action: PayloadAction<IGetFacilityTypeDocumentMappingResponse>) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.mapping = action.payload.data;
      })
      .addCase(getFacilityTypeDocumentMapping.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetGetFacilityTypeDocumentMappingState } = getFacilityTypeDocumentMappingSlice.actions;
export const getFacilityTypeDocumentMappingReducer = getFacilityTypeDocumentMappingSlice.reducer;

// Cancellation Reasons Slices

// Search Cancellation Reasons Slice
const initialSearchCancellationReasonsState: ISearchCancellationReasonsState = {
  loading: false,
  success: false,
  error: null,
  reasons: [],
  count: 0,
};

const searchCancellationReasonsSlice = createSlice({
  name: 'searchCancellationReasons',
  initialState: initialSearchCancellationReasonsState,
  reducers: {
    resetSearchCancellationReasonsState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.reasons = [];
      state.count = 0;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchCancellationReasons.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(searchCancellationReasons.fulfilled, (state, action: PayloadAction<ISearchCancellationReasonsResponse>) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        if (action.payload && action.payload.data) {
          state.reasons = action.payload.data;
          state.count = action.payload.data.length;
        } else {
          // Fallback or empty
          state.reasons = [];
          state.count = 0;
        }
      })
      .addCase(searchCancellationReasons.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetSearchCancellationReasonsState } = searchCancellationReasonsSlice.actions;
export const searchCancellationReasonsReducer = searchCancellationReasonsSlice.reducer;

// Create Cancellation Reason Slice
const initialCreateCancellationReasonState: ICreateCancellationReasonState = {
  loading: false,
  success: false,
  error: null,
  message: null,
};

const createCancellationReasonSlice = createSlice({
  name: 'createCancellationReason',
  initialState: initialCreateCancellationReasonState,
  reducers: {
    resetCreateCancellationReasonState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.message = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createCancellationReason.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(createCancellationReason.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.message = 'Cancellation reason created successfully';
      })
      .addCase(createCancellationReason.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
        state.message = null;
      });
  },
});

export const { resetCreateCancellationReasonState } = createCancellationReasonSlice.actions;
export const createCancellationReasonReducer = createCancellationReasonSlice.reducer;

// Update Cancellation Reason Slice
const initialUpdateCancellationReasonState: IUpdateCancellationReasonState = {
  loading: false,
  success: false,
  error: null,
  message: null,
};

const updateCancellationReasonSlice = createSlice({
  name: 'updateCancellationReason',
  initialState: initialUpdateCancellationReasonState,
  reducers: {
    resetUpdateCancellationReasonState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.message = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateCancellationReason.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(updateCancellationReason.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.message = 'Cancellation reason updated successfully';
      })
      .addCase(updateCancellationReason.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
        state.message = null;
      });
  },
});

export const { resetUpdateCancellationReasonState } = updateCancellationReasonSlice.actions;
export const updateCancellationReasonReducer = updateCancellationReasonSlice.reducer;

// Delete Cancellation Reason Slice
const initialDeleteCancellationReasonState: IDeleteCancellationReasonState = {
  loading: false,
  success: false,
  error: null,
  message: null,
};

const deleteCancellationReasonSlice = createSlice({
  name: 'deleteCancellationReason',
  initialState: initialDeleteCancellationReasonState,
  reducers: {
    resetDeleteCancellationReasonState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.message = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteCancellationReason.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(deleteCancellationReason.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.message = 'Cancellation reason deleted successfully';
      })
      .addCase(deleteCancellationReason.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
        state.message = null;
      });
  },
});

export const { resetDeleteCancellationReasonState } = deleteCancellationReasonSlice.actions;
export const deleteCancellationReasonReducer = deleteCancellationReasonSlice.reducer;

// Search Banks Slice
const initialSearchBanksState: ISearchBankState = {
  loading: false,
  success: false,
  error: null,
  banks: [],
  count: 0,
};

const searchBanksSlice = createSlice({
  name: 'searchBanks',
  initialState: initialSearchBanksState,
  reducers: {
    resetSearchBanksState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.banks = [];
      state.count = 0;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchBanks.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(searchBanks.fulfilled, (state, action: any) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        if (action.payload && action.payload.results) {
          state.banks = action.payload.results;
          state.count = action.payload.count;
        } else if (action.payload && action.payload.data && action.payload.data.results) {
          state.banks = action.payload.data.results;
          state.count = action.payload.data.count;
        } else {
          // fallback if structure is different
          state.banks = [];
          state.count = 0;
        }
      })
      .addCase(searchBanks.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetSearchBanksState } = searchBanksSlice.actions;
export const searchBanksReducer = searchBanksSlice.reducer;

// Upload Bank CSV Slice
const initialUploadBankCSVState: IUploadBankCSVState = {
  loading: false,
  success: false,
  error: null,
  message: null,
};

const uploadBankCSVSlice = createSlice({
  name: 'uploadBankCSV',
  initialState: initialUploadBankCSVState,
  reducers: {
    resetUploadBankCSVState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.message = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadBankCSV.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(uploadBankCSV.fulfilled, (state, action: PayloadAction<{ status: boolean; message: string }>) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.message = action.payload.message || 'File uploaded successfully';
      })
      .addCase(uploadBankCSV.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
        state.message = null;
      });
  },
});

export const { resetUploadBankCSVState } = uploadBankCSVSlice.actions;
export const uploadBankCSVReducer = uploadBankCSVSlice.reducer;

// Config Slices

// Create Config Slice
const initialCreateConfigState: ICreateConfigState = {
  loading: false,
  success: false,
  error: null,
  config: null,
};

const createConfigSlice = createSlice({
  name: 'createConfig',
  initialState: initialCreateConfigState,
  reducers: {
    resetCreateConfigState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.config = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createConfig.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(createConfig.fulfilled, (state, action: PayloadAction<ICreateConfigResponse>) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        if (action.payload && action.payload.data) {
          state.config = action.payload.data;
        } else {
          // fallback
          state.config = action.payload as unknown as IConfig;
        }
      })
      .addCase(createConfig.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetCreateConfigState } = createConfigSlice.actions;
export const createConfigReducer = createConfigSlice.reducer;

// Search Config Slice
const initialSearchConfigState: ISearchConfigState = {
  loading: false,
  success: false,
  error: null,
  configs: [],
  count: 0,
};

const searchConfigsSlice = createSlice({
  name: 'searchConfigs',
  initialState: initialSearchConfigState,
  reducers: {
    resetSearchConfigState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.configs = [];
      state.count = 0;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchConfigs.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(searchConfigs.fulfilled, (state, action: any) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        if (action.payload && action.payload.results) {
          state.configs = action.payload.results;
          state.count = action.payload.count;
        } else if (action.payload && action.payload.data && action.payload.data.results) {
          state.configs = action.payload.data.results;
          state.count = action.payload.data.count;
        }
        // Handle cases where data is just a list or single object if logic is different, 
        // but assuming paginated response like others
        else {
          state.configs = [];
          state.count = 0;
        }
      })
      .addCase(searchConfigs.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetSearchConfigState } = searchConfigsSlice.actions;
export const searchConfigsReducer = searchConfigsSlice.reducer;

// Update Config Slice
const initialUpdateConfigState: IUpdateConfigState = {
  loading: false,
  success: false,
  error: null,
};

const updateConfigSlice = createSlice({
  name: 'updateConfig',
  initialState: initialUpdateConfigState,
  reducers: {
    resetUpdateConfigState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateConfig.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateConfig.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(updateConfig.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetUpdateConfigState } = updateConfigSlice.actions;
export const updateConfigReducer = updateConfigSlice.reducer;

// Delete Config Slice
const initialDeleteConfigState: IDeleteConfigState = {
  loading: false,
  success: false,
  error: null,
};

const deleteConfigSlice = createSlice({
  name: 'deleteConfig',
  initialState: initialDeleteConfigState,
  reducers: {
    resetDeleteConfigState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteConfig.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(deleteConfig.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(deleteConfig.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetDeleteConfigState } = deleteConfigSlice.actions;
export const deleteConfigReducer = deleteConfigSlice.reducer;

// List Config Slice (No Pagination)
const initialListConfigState: IListConfigState = {
  loading: false,
  success: false,
  error: null,
  configs: [],
};

const listConfigsSlice = createSlice({
  name: 'listConfigs',
  initialState: initialListConfigState,
  reducers: {
    resetListConfigState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.configs = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(listConfigs.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(listConfigs.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        if (action.payload && Array.isArray(action.payload.data)) {
          state.configs = action.payload.data;
        } else if (Array.isArray(action.payload)) {
          // Fallback if it is sent directly
          state.configs = action.payload;
        } else {
          state.configs = [];
        }
      })
      .addCase(listConfigs.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetListConfigState } = listConfigsSlice.actions;
export const listConfigsReducer = listConfigsSlice.reducer;


// Custom Form Slice

const initialCustomFormState: CustomFormState = {
  forms: [],
  loading: false,
  error: null,
  success: false,
};

const customFormSlice = createSlice({
  name: 'customForm',
  initialState: initialCustomFormState,
  reducers: {
    clearCustomFormState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    // Fetch Custom Forms
    builder.addCase(fetchCustomForms.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchCustomForms.fulfilled, (state, action: PayloadAction<CustomForm[]>) => {
      state.loading = false;
      state.forms = action.payload;
      state.error = null;
    });
    builder.addCase(fetchCustomForms.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });

    // Create Custom Form
    builder.addCase(createCustomForm.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    });
    builder.addCase(createCustomForm.fulfilled, (state, action: any) => {
      state.loading = false;
      if (action.payload && action.payload.data) {
        state.forms.push(action.payload.data);
      } else if (action.payload && action.payload.id) {
        state.forms.push(action.payload);
      }
      state.success = true;
      state.error = null;
    });
    builder.addCase(createCustomForm.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
      state.success = false;
    });

    // Update Custom Form
    builder.addCase(updateCustomForm.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    });
    builder.addCase(updateCustomForm.fulfilled, (state, action: any) => {
      state.loading = false;
      state.success = true;
      state.error = null;
      // Ideally update the specific item in the array if needed
      // state.forms = state.forms.map(f => f.id === action.payload.data.id ? action.payload.data : f);
      // But typically we re-fetch effectively, or we can update local state.
      // If we re-fetch in the component on success, this is less critical, 
      // but updating local state is better for UX if re-fetch is skipped.
      if (action.payload && action.payload.data) {
        state.forms = state.forms.map(f => f.form_id === action.payload.data.form_id ? action.payload.data : f);
      }
    });
    builder.addCase(updateCustomForm.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
      state.success = false;
    });
  },
});

export const { clearCustomFormState } = customFormSlice.actions;
export const customFormReducer = customFormSlice.reducer;

// Map Inputs To Form Slice

const initialMapInputsToFormState: IMapInputsToFormState = {
  loading: false,
  success: false,
  error: null,
  message: null,
};

const mapInputsToFormSlice = createSlice({
  name: 'mapInputsToForm',
  initialState: initialMapInputsToFormState,
  reducers: {
    resetMapInputsToFormState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(mapInputsToForm.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(mapInputsToForm.fulfilled, (state, action: PayloadAction<IMapInputsToFormResponse>) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.message = action.payload.message;
      })
      .addCase(mapInputsToForm.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetMapInputsToFormState } = mapInputsToFormSlice.actions;
export const mapInputsToFormReducer = mapInputsToFormSlice.reducer;

// Delete Custom Form Slice

const initialDeleteCustomFormState: IDeleteCustomFormState = {
  loading: false,
  success: false,
  error: null,
  message: null,
};

const deleteCustomFormSlice = createSlice({
  name: 'deleteCustomForm',
  initialState: initialDeleteCustomFormState,
  reducers: {
    resetDeleteCustomFormState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteCustomForm.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(deleteCustomForm.fulfilled, (state, action: PayloadAction<IDeleteCustomFormResponse>) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.message = action.payload.message;
      })
      .addCase(deleteCustomForm.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetDeleteCustomFormState } = deleteCustomFormSlice.actions;
export const deleteCustomFormReducer = deleteCustomFormSlice.reducer;

// Publish Custom Form Slice

const initialPublishCustomFormState: IPublishCustomFormState = {
  loading: false,
  success: false,
  error: null,
  message: null,
};

const publishCustomFormSlice = createSlice({
  name: 'publishCustomForm',
  initialState: initialPublishCustomFormState,
  reducers: {
    resetPublishCustomFormState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(publishCustomForm.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(publishCustomForm.fulfilled, (state, action: PayloadAction<IPublishCustomFormResponse>) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.message = action.payload.message;
      })
      .addCase(publishCustomForm.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetPublishCustomFormState } = publishCustomFormSlice.actions;
export const publishCustomFormReducer = publishCustomFormSlice.reducer;



// Get Custom Form Fields Slice
const initialGetCustomFormFieldsState: IGetCustomFormFieldsState = {
  loading: false,
  success: false,
  error: null,
  fields: [],
};

const getCustomFormFieldsSlice = createSlice({
  name: 'getCustomFormFields',
  initialState: initialGetCustomFormFieldsState,
  reducers: {
    resetGetCustomFormFieldsState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.fields = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomFormFields.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(getCustomFormFields.fulfilled, (state, action: PayloadAction<IGetCustomFormFieldsResponse>) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        if (action.payload.data) {
          state.fields = action.payload.data;
        } else {
          // fallback if data is directly the array
          state.fields = action.payload as unknown as any[];
        }
      })
      .addCase(getCustomFormFields.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetGetCustomFormFieldsState } = getCustomFormFieldsSlice.actions;
export const getCustomFormFieldsReducer = getCustomFormFieldsSlice.reducer;

// Add Custom Form Field Slice
const initialAddCustomFormFieldState: IAddCustomFormFieldState = {
  loading: false,
  success: false,
  error: null,
};

const addCustomFormFieldSlice = createSlice({
  name: 'addCustomFormField',
  initialState: initialAddCustomFormFieldState,
  reducers: {
    resetAddCustomFormFieldState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addCustomFormField.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(addCustomFormField.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(addCustomFormField.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetAddCustomFormFieldState } = addCustomFormFieldSlice.actions;
export const addCustomFormFieldReducer = addCustomFormFieldSlice.reducer;

// Delete Custom Form Field Slice
const initialDeleteCustomFormFieldState: IDeleteCustomFormFieldState = {
  loading: false,
  success: false,
  error: null,
  message: null
};

const deleteCustomFormFieldSlice = createSlice({
  name: 'deleteCustomFormField',
  initialState: initialDeleteCustomFormFieldState,
  reducers: {
    resetDeleteCustomFormFieldState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.message = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteCustomFormField.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(deleteCustomFormField.fulfilled, (state, action: PayloadAction<IDeleteCustomFormFieldResponse>) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.message = action.payload.message;
      })
      .addCase(deleteCustomFormField.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
        state.message = null;
      });
  },
});

export const { resetDeleteCustomFormFieldState } = deleteCustomFormFieldSlice.actions;
export const deleteCustomFormFieldReducer = deleteCustomFormFieldSlice.reducer;

// Get Bank Form Fields Slice
const initialGetBankFormFieldsState: IGetBankFormFieldsState = {
  loading: false,
  success: false,
  error: null,
  fields: [],
};

const getBankFormFieldsSlice = createSlice({
  name: 'getBankFormFields',
  initialState: initialGetBankFormFieldsState,
  reducers: {
    resetGetBankFormFieldsState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.fields = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBankFormFields.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(getBankFormFields.fulfilled, (state, action: PayloadAction<IGetBankFormFieldsResponse>) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        if (action.payload.data) {
          state.fields = action.payload.data;
        } else {
          // fallback if data is directly the array
          state.fields = action.payload as unknown as any[];
        }
      })
      .addCase(getBankFormFields.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetGetBankFormFieldsState } = getBankFormFieldsSlice.actions;
export const getBankFormFieldsReducer = getBankFormFieldsSlice.reducer;

// Bank Form List Slice
const initialBankFormListState: IBankFormListState = {
  loading: false,
  success: false,
  error: null,
  forms: [],
};

const bankFormListSlice = createSlice({
  name: 'bankFormList',
  initialState: initialBankFormListState,
  reducers: {
    resetBankFormListState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.forms = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBankForms.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(getBankForms.fulfilled, (state, action: PayloadAction<IBankFormListResponse>) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        if (action.payload.data) {
          state.forms = action.payload.data;
        } else {
          state.forms = action.payload as unknown as any[];
        }
      })
      .addCase(getBankForms.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetBankFormListState } = bankFormListSlice.actions;
export const bankFormListReducer = bankFormListSlice.reducer;

// Create Bank Form Field Slice
const initialCreateBankFormFieldState: ICreateBankFormFieldState = {
  loading: false,
  success: false,
  error: null,
  field: null,
};

const createBankFormFieldSlice = createSlice({
  name: 'createBankFormField',
  initialState: initialCreateBankFormFieldState,
  reducers: {
    resetCreateBankFormFieldState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.field = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createBankFormField.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(createBankFormField.fulfilled, (state, action: PayloadAction<ICreateBankFormFieldResponse>) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        if (action.payload.data) {
          state.field = action.payload.data;
        } else {
          state.field = action.payload as unknown as any;
        }
      })
      .addCase(createBankFormField.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetCreateBankFormFieldState } = createBankFormFieldSlice.actions;
export const createBankFormFieldReducer = createBankFormFieldSlice.reducer;

// Update Custom Form Field Slice
const initialUpdateCustomFormFieldState: IUpdateCustomFormFieldState = {
  loading: false,
  success: false,
  error: null,
};

const updateCustomFormFieldSlice = createSlice({
  name: 'updateCustomFormField',
  initialState: initialUpdateCustomFormFieldState,
  reducers: {
    resetUpdateCustomFormFieldState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateCustomFormField.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateCustomFormField.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(updateCustomFormField.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetUpdateCustomFormFieldState } = updateCustomFormFieldSlice.actions;
export const updateCustomFormFieldReducer = updateCustomFormFieldSlice.reducer;

// Update Bank Form Field Slice
const initialUpdateBankFormFieldState: IUpdateBankFormFieldState = {
  loading: false,
  success: false,
  error: null,
};

const updateBankFormFieldSlice = createSlice({
  name: 'updateBankFormField',
  initialState: initialUpdateBankFormFieldState,
  reducers: {
    resetUpdateBankFormFieldState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateBankFormField.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateBankFormField.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(updateBankFormField.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetUpdateBankFormFieldState } = updateBankFormFieldSlice.actions;
export const updateBankFormFieldReducer = updateBankFormFieldSlice.reducer;

// Delete Bank Form Field Slice
const initialDeleteBankFormFieldState: IDeleteBankFormFieldState = {
  loading: false,
  success: false,
  error: null,
};

const deleteBankFormFieldSlice = createSlice({
  name: 'deleteBankFormField',
  initialState: initialDeleteBankFormFieldState,
  reducers: {
    resetDeleteBankFormFieldState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteBankFormField.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(deleteBankFormField.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(deleteBankFormField.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetDeleteBankFormFieldState } = deleteBankFormFieldSlice.actions;
export const deleteBankFormFieldReducer = deleteBankFormFieldSlice.reducer;

// Soft Delete Bank Form Field Slice
const initialSoftDeleteBankFormFieldState: ISoftDeleteBankFormFieldState = {
  loading: false,
  success: false,
  error: null,
};

const softDeleteBankFormFieldSlice = createSlice({
  name: 'softDeleteBankFormField',
  initialState: initialSoftDeleteBankFormFieldState,
  reducers: {
    resetSoftDeleteBankFormFieldState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(softDeleteBankFormField.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(softDeleteBankFormField.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(softDeleteBankFormField.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetSoftDeleteBankFormFieldState } = softDeleteBankFormFieldSlice.actions;
export const softDeleteBankFormFieldReducer = softDeleteBankFormFieldSlice.reducer;
